import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import styles from "./Add.module.scss";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import PageHeader from "components/PageHeader/PageHeader";
import Container from "components/Container/Container";
import FormElement from "components/FormElement/FormElement";
import Select from "components/Select/Select";
import SelectAlt from "components/SelectAlt/SelectAlt";
import Row from "components/Row/Row";
import Radio from "components/Radio/Radio";
import UploadDocuments from "../components/UploadDocuments/UploadDocuments";
import HR from "components/HR/HR";
import Button from "components/Button/Button";
import { submitAddAffiliateFormAction, readAffiliateAgreementsAction } from "store/actions/Actions";
import { states, statesObj, toggleDropdowns } from "helpers/utils";

const Add = props => {

    const { AffiliateAgreementsReducer, readAffiliateAgreementsAction, AddAffiliateFormReducer } = props;

    const [state, setState] = useState({
        name: "",
        phi: false,
        contact_first: "",
        contact_last: "",
        contact_email: "",
        phone: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        state_name: "",
        // region: "",
        country_code: 235,
        postal_code: "",
        notes: "",
        ba_agreement_id: "",
        conf_agreement_id: "",
    });

    const [stateErrors, setStateErrors] = useState({});
    const [documents, setDocuments] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const baDropdownRef = React.createRef();
    const confDropdownRef = React.createRef();

    useEffect(() => {
        const state_name = statesObj[state.state] || state.state;
        if (state_name) {
          setState((s) => ({
            ...s,
            state_name,
          }));  
        }
      }, [state.state]);

    useEffect(() => {
        if (!AffiliateAgreementsReducer.files) {
            readAffiliateAgreementsAction();
        }
    }, [AffiliateAgreementsReducer.files, readAffiliateAgreementsAction]);

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]:
                e.target.type === "checkbox"
                    ? e.target.checked : e.target.value === "true" ? true
                    : e.target.value === "false" ? false : e.target.value
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const handleSelectChange = (inputName) => (e) => {
        let inputType = e.target.getAttribute('value');
        setState((s) => ({ ...s, [inputName]: `${inputType}`}));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const handleSelectAlt = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.dataset.name,
            [e.target.dataset.attr]: e.target.dataset.id,
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const submitAddAffiliate = () => {
        if (
            state.name === "" ||
            state.contact_first === "" ||
            state.contact_last === "" ||
            state.contact_email === "" ||
            state.phone === "" ||
            state.address_1 === "" ||
            state.city === "" ||
            // state.region === "" ||
            state.postal_code === ""
        ) {
            setStateErrors({
                ...stateErrors,
                name: state.name === "" ? "Name is required" : "",
                contact_first: state.contact_first === "" ? "First name is required" : "",
                contact_last: state.contact_last === "" ? "Last name is required" : "",
                contact_email: state.contact_email === "" ? "Email is required" : "",
                phone: state.phone === "" ? "Phone is required" : "",
                address_1: state.address_1 === "" ? "Address is required" : "",
                city: state.city === "" ? "City is required" : "",
                region: state.state_name === "" ? "State/Region is required" : "",
                postal_code: state.postal_code === "" ? "Postal code is required" : "",
            });
        } else {
            props.submitAddAffiliateFormAction({ ...state, documents });
        }
        window.scrollTo(0, 0);
    };

    // [OPTIONAL]
    // A way to close dropdowns when clicking on parent if they are open
    const stateDropdownRef = React.createRef();

    const filesLabels = {};
    AffiliateAgreementsReducer.files && AffiliateAgreementsReducer.files.forEach(item => {
        filesLabels[item.id] = item.folder_name;
    });

    const filteredStates = state.state_name ? 
        states.filter(s => s.name && s.name.toLowerCase().includes(state.state_name && state.state_name.toLowerCase()))
        :
        states;

    return (
        <AppLayoutWrapFull>
            <PageHeader />
            <div id="modal-root"></div>
            <Container>
                <form
                    className={styles.form}
                    onClick={toggleDropdowns([
                        stateDropdownRef,
                        baDropdownRef,
                        confDropdownRef,
                    ])}
                >
                    <FormElement
                        labelText="NAME"
                        htmlFor="name"
                        errorMessage={stateErrors.name}
                    >
                        <input
                            name="name"
                            type="text"
                            placeholder="Enter Affiliate Name"
                            value={state["name"]}
                            onChange={handleChange("name")}
                        />
                    </FormElement>
                    <FormElement
                        labelText="AGREEMENT LEVEL"
                        htmlFor="agreement-level"
                        errorMessage={stateErrors.phi}
                    >
                        <Row className={styles["phi"]}>
                            <Radio
                                checked={state.phi}
                                labelText="Business Associate"
                                onChange={handleChange("phi")}
                                value={true}
                            />
                            <Radio
                                checked={!state.phi}
                                labelText="Confidentiality"
                                onChange={handleChange("phi")}
                                value={false}
                            />
                        </Row>
                    </FormElement>

                    <FormElement
                        labelText="FIRST NAME"
                        htmlFor="contact_first"
                        errorMessage={stateErrors.contact_first}
                    >
                        <input
                            name="contact_first"
                            type="text"
                            placeholder="Enter Affiliate Contact First Name"
                            value={state["contact_first"]}
                            onChange={handleChange("contact_first")}
                        />
                    </FormElement>

                    <FormElement
                        labelText="LAST NAME"
                        htmlFor="contact_last"
                        errorMessage={stateErrors.contact_last}
                    >
                        <input
                            name="contact_last"
                            type="text"
                            placeholder="Enter Affiliate Contact Last Name"
                            value={state["contact_last"]}
                            onChange={handleChange("contact_last")}
                        />
                    </FormElement>

                    <FormElement
                        labelText="CONTACT EMAIL"
                        htmlFor="contact_email"
                        className={styles["contact-email"]}
                        errorMessage={stateErrors["contact_email"]}
                    >
                        <input
                            name="contact_email"
                            type="email"
                            placeholder="Enter Affiliate Contact Email"
                            value={state["contact_email"]}
                            onChange={handleChange("contact_email")}
                        />
                    </FormElement>
                    <FormElement
                        noLabel={true}
                        errorMessage={stateErrors["phone"]}
                    >
                        <label htmlFor="phone">CONTACT PHONE</label>
                        <Row className={styles["form-group-row"]}>
                            <input
                                className={styles["contact-phone-input"]}
                                name="phone"
                                type="text"
                                placeholder="Enter Affiliate Contact Phone"
                                value={state['phone']}
                                onChange={handleChange("phone")}
                            />
                        </Row>
                    </FormElement>
                    <FormElement
                        labelText="ADDRESS"
                        htmlFor="address_1"
                        errorMessage={stateErrors["address_1"]}
                    >
                        <input
                            name="address_1"
                            type="text"
                            placeholder="Street and number"
                            value={state.address_1}
                            onChange={handleChange("address_1")}
                        />
                    </FormElement>

                    <span>&nbsp;</span>

                    <FormElement
                        // labelText="ADDRESS 2"
                        htmlFor="address_2"
                        errorMessage={stateErrors["address_2"]}
                    >
                        <input
                            name="address_2"
                            type="text"
                            placeholder="Apartment, building, floor (optional)"
                            value={state.address_2}
                            onChange={handleChange("address_2")}
                        />
                    </FormElement>

                    <span>&nbsp;</span>

                    <Row
                        className={`${styles["form-group-row"]} ${
                            styles["city-state-postal_code"]
                        }`}
                    >
                        <FormElement
                            labelText="CITY"
                            htmlFor="city"
                            errorMessage={stateErrors["city"]}
                            >
                            <input
                                name="city"
                                type="text"
                                placeholder="City"
                                value={state.city}
                                onChange={handleChange("city")}
                            />
                        </FormElement>

                        <FormElement
                            labelText="STATE / REGION"
                            htmlFor="state"
                            errorMessage={stateErrors.state_name}
                            >
                            <SelectAlt
                                placeholder="State"
                                dropdownToggleRef={stateDropdownRef}
                                value={state.state_name}
                                onClick={handleSelectAlt("state")}
                                setState={setState}
                                labels={statesObj}
                            >
                                {filteredStates.map(item => <li key={item.abbrev} data-attr="state" data-id={item.abbrev} data-name={item.name} value={item.name}>{item.name}</li>)}
                            </SelectAlt>
                        </FormElement>

                        <FormElement
                            labelText="POSTAL CODE"
                            htmlFor="postal_code"
                            errorMessage={stateErrors["postal_code"]}
                        >
                            <input
                                name="postal_code"
                                type="text"
                                placeholder="Postal Code"
                                value={state.postal_code}
                                onChange={handleChange("postal_code")}
                            />
                        </FormElement>
                    </Row>

                    <span>&nbsp;</span>

                    <FormElement
                        labelText="BA Agreement"
                        htmlFor="ba_agreement_id"
                    >
                        <Select
                            name="ba_agreement_id"
                            value={state.ba_agreement_id}
                            placeholder="Select BA Agreement document"
                            onClick={handleSelectChange("ba_agreement_id")}
                            dropdownToggleRef={baDropdownRef}
                            labels={filesLabels}
                        >
                            {AffiliateAgreementsReducer.files && AffiliateAgreementsReducer.files.map(file => {
                                    return <li key={`ba_agreement_id-${file.id}`} value={file.id}>{file.folder_name}</li>
                                }
                            )}

                        </Select>
                    </FormElement>

                    <FormElement
                        labelText="Confidentiality Agreement"
                        htmlFor="conf_agreement_id"
                    >
                        <Select
                            name="conf_agreement_id"
                            value={state.conf_agreement_id}
                            placeholder="Select Confidentiality Agreement document"
                            onClick={handleSelectChange("conf_agreement_id")}
                            dropdownToggleRef={confDropdownRef}
                            labels={filesLabels}
                        >
                            {AffiliateAgreementsReducer.files && AffiliateAgreementsReducer.files.map(file => {
                                    return <li key={`conf_agreement_id-${file.id}`} value={file.id}>{file.folder_name}</li>
                                }
                            )}
                        </Select>
                    </FormElement>

                    <br />

                    <UploadDocuments
                        documents={documents || []}
                        setDocuments={setDocuments}
                        setShowModal={setShowModal}
                        showModal={showModal}
                        className={styles["upload-documents"]}
                    />
                    <FormElement labelText="NOTES" htmlFor="notes">
                        <textarea
                            className={styles.notes || ""}
                            value={state.notes}
                            onChange={handleChange("notes")}
                        />
                    </FormElement>
                    <HR className={styles["hr"]} />
                    <div className={styles["form-options"]}>
                        <Button
                            onClick={() => props.history.push("/achieve/affiliates")}
                            className={styles.button}
                            text="CANCEL"
                            color="secondary"
                        />
                        <Button
                            className={styles.button}
                            text="ADD AFFILIATE"
                            disabled={AddAffiliateFormReducer.status === 'ISBUSY'}
                            icon={AddAffiliateFormReducer.status === 'ISBUSY' ? "fad fa-spinner-third fa-spin" : "far fa-plus"}
                            onClick={submitAddAffiliate}
                        />
                    </div>
                </form>
            </Container>
        </AppLayoutWrapFull>
    );
};


const mapStateToProps = state => ({
    AddAffiliateFormReducer: state.AddAffiliateFormReducer,
    AffiliateAgreementsReducer: state.AffiliateAgreementsReducer,
});

const mapDispatchToProps = {
    submitAddAffiliateFormAction,
    readAffiliateAgreementsAction,

};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Add);
